import RateShopTypes from './RateShopTypes';

export const getCarriersByCustomerInProgress = (payload) => ({
  type: RateShopTypes.GET_CARRIERS_BY_CUSTOMER_PROGRESS,
  payload,
});
export const getCarriersByCustomerInSuccess = (payload) => ({
  type: RateShopTypes.GET_CARRIERS_BY_CUSTOMER_SUCCESS,
  payload,
});
export const getCarriersByCustomerInError = (payload) => ({
  type: RateShopTypes.GET_CARRIERS_BY_CUSTOMER_ERROR,
  payload,
});

export const getAccessorialsListInProgress = (payload) => ({
  type: RateShopTypes.GET_ACCESSORIALS_LIST_PROGRESS,
  payload,
});
export const getAccessorialsListInSuccess = (payload) => ({
  type: RateShopTypes.GET_ACCESSORIALS_LIST_SUCCESS,
  payload,
});
export const getAccessorialsListInError = (payload) => ({
  type: RateShopTypes.GET_ACCESSORIALS_LIST_ERROR,
  payload,
});

export const getTaxListInProgress = (payload) => ({
  type: RateShopTypes.GET_TAX_LIST_PROGRESS,
  payload,
});
export const getTaxListInSuccess = (payload) => ({
  type: RateShopTypes.GET_TAX_LIST_SUCCESS,
  payload,
});
export const getTaxListInError = (payload) => ({
  type: RateShopTypes.GET_TAX_LIST_ERROR,
  payload,
});

export const setGlobalRateShopTab = (payload) => ({
  type: RateShopTypes.SET_GLOBAL_RATE_SHOP_TAB,
  payload,
});

export const setRateShopLaneTab = (payload) => ({
  type: RateShopTypes.SET_RATE_SHOP_LANE_TAB,
  payload,
});

export const setRateShopLaneStopTab = (payload) => ({
  type: RateShopTypes.SET_RATE_SHOP_LANE_STOP_TAB,
  payload,
});

export const setRateShopStopsDrawer = (payload) => ({
  type: RateShopTypes.SET_RATE_SHOP_STOPS_DRAWER,
  payload,
});

export const setRateShopGlobalMeasurementUnit = (payload) => ({
  type: RateShopTypes.SET_GLOBAL_RATE_SHOP_MEASUREMENT_UNIT,
  payload,
});

export const getRateShopResultsForRateShopModuleProgress = (payload) => ({
  type: RateShopTypes.GET_RATE_RESULTS_PROGRESS,
  payload,
});
export const getRateShopResultsForRateShopModuleSuccess = (payload) => ({
  type: RateShopTypes.GET_RATE_RESULTS_SUCCESS,
  payload,
});
export const getRateShopResultsForRateShopModuleError = (payload) => ({
  type: RateShopTypes.GET_RATE_RESULTS_ERROR,
  payload,
});

export const setSelectedRateShopCarrierRate = (payload) => ({
  type: RateShopTypes.SET_SELECTED_CARRIER_RATE,
  payload,
});

export const setSelectedRateShopCargoType = (payload) => ({
  type: RateShopTypes.SET_SELECTED_CARGO_TYPES,
  payload,
});

export const setRateShopItemsSumValues = (payload) => ({
  type: RateShopTypes.SET_ITEMS_SUM_VALUES,
  payload,
});
